const DROM_COM_PREFIXES = [
  '971',
  '972',
  '973',
  '974',
  '975',
  '976',
  '984',
  '986',
  '987',
  '988',
];

function normalizeValue(value) {
  return `${value || ''}`.trim();
}

function isDromComAddress(countryCode, postalCode) {
  const normalizedCountryCode = normalizeValue(countryCode).toUpperCase();
  const normalizedPostalCode = normalizeValue(postalCode);

  return (
    normalizedCountryCode === 'FR' &&
    DROM_COM_PREFIXES.some((prefix) => normalizedPostalCode.indexOf(prefix) === 0)
  );
}

function getUnsupportedShippingAddressError() {
  return 'Delivery to overseas territories is not available (postal codes 971, 972, 973, 974, 975, 976, 984, 986, 987, 988)';
}

module.exports = {
  getUnsupportedShippingAddressError,
  isDromComAddress,
};
